module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAARVBMVEXvKy35sBv80RbzXCb2gSH6txrwPir0byT4nR33jx93ZTuYgDIAnkmYvSqRvCv0zxgMoEfvzxhrtDOLui1VrzgmpkFBqzw6Zzq5AAAAsklEQVR4Ae3PBZKEUBRD0TfB3dn/TsetHctvyynBuRWTpyYiIiIiIi/Gh8doAJ6DBozMd9DAu4DfYA8JHTTwKeI3CEOif/Al+uPbJnBGbBvxcIptaNoIQiSxidKJMuxLp7J8Muwo8sksXxYpc34D99uo8F9NaWBHQ2y0P3sYjfLvz7QGPvw77ziNPv/RANi+sf9TYCA0Lt2Y3phudNDI1VBDDTXUUINJDTXUUEMNNdTgegOtSeQMooXI/gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Burkina Faso.png
// module id = 564
// module chunks = 0